import { AppBar } from '@material-ui/core'
import { useMemo, useState } from 'react'

import Breadcrumbs from '../../components/Breadcrumb'
import { getTranslate } from '../../localization'
import GatewayAddHeader from './GatewayAddHeader'
import GateWayMainForm from './GatewayMainForm'
import useStyles from './styles/index.styles'

const GatewayFormEdit = () => {
  const classes = useStyles()
  const [nameForBreadcrumbs, setNameForBreadcrumbs] = useState<string>('')

  const cachedLevels = useMemo(
    () => [
      {
        label: getTranslate('Gateway'),
        link: '/gateway'
      },
      {
        label: getTranslate(nameForBreadcrumbs ? `${nameForBreadcrumbs}` : '')
      }
    ],
    [nameForBreadcrumbs]
  )

  return (
    <div>
      <div className={classes.root}>
        <AppBar
          className={classes.appBar}
          position="static"
          color="transparent">
          <Breadcrumbs levels={cachedLevels} loading={!nameForBreadcrumbs} />
        </AppBar>
        <div className={classes.contentContainer}>
          <GatewayAddHeader />
          <GateWayMainForm setNameForBreadcrumbs={setNameForBreadcrumbs} />
        </div>
      </div>
    </div>
  )
}
export default GatewayFormEdit
